var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagGabon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5759C31.648 19.8426 32 17.9678 32 16.0107C32 14.0536 31.648 12.1789 31.0048 10.4455L16 9.0542L0.995188 10.4455C0.352063 12.1789 0 14.0536 0 16.0107C0 17.9678 0.352063 19.8426 0.995188 21.5759L16 22.9672L31.0048 21.5759Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C22.8794 32.0107 28.7441 27.6687 31.0047 21.5759H0.995125C3.25587 27.6687 9.1205 32.0107 16 32.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0107422C9.1205 0.0107422 3.25587 4.35274 0.995125 10.4456H31.0048C28.7441 4.35274 22.8794 0.0107422 16 0.0107422Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGabon);
export default __webpack_public_path__ + "static/media/flag_gabon.aed5617af8567d64c68f3a67dbbdab78.svg";
export { ForwardRef as ReactComponent };